import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

export function AiDraftNewMessageHint() {
    return (
        <span className="mt-2 inline-flex items-center gap-1 text-[11px] font-medium text-amber-700">
            <ExclamationCircleIcon className="h-3.5 w-3.5" aria-hidden="true" />
            New message since this draft
        </span>
    );
}
